import { MdOutlineThumbDown, MdOutlineThumbUpAlt } from "react-icons/md";
import styles from "./like_dislike.module.scss";

export const LikeDislike = () => {
  return (
    <section className={styles.section_like_deslike}>
      <div className="container">
        <div className={styles.wrapper}>
          <div className={styles.content_wrapper}>
            <div className={styles.title}>Was this page helpful?</div>
            <div className={styles.button_wrapper}>
              <button className="btn btn-secondary">
                <MdOutlineThumbUpAlt />
                <span>Like</span>
              </button>
              <button className="btn btn-secondary">
                <MdOutlineThumbDown />
                <span>Dislike</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LikeDislike;
